module.exports = __webpack_public_path__ + "static/media/rocket1.01fea637.png";